import { ClickAndReserve } from '../feature-config.enum.js';
import { useFeatureToggles } from '../../../FeatureToggles/Context/Context.js';

const useClickAndReserveFeatureConfig = ()=>{
    const { featureConfigs , isClickAndReserveEnabled  } = useFeatureToggles();
    if (isClickAndReserveEnabled) {
        if ((featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.clickAndReserve) === ClickAndReserve.STOCK) {
            return 'stock_only';
        } else if ((featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.clickAndReserve) === ClickAndReserve.STOCK_RESERVATION) {
            return 'reservation';
        }
    }
};

export { useClickAndReserveFeatureConfig };
//# sourceMappingURL=use-click-and-reserve-feature-config.js.map
